const urlParamss = new URLSearchParams(window.location.search);
const savedQueryParams = JSON.parse(sessionStorage.getItem('queryParams'));
const queryParams = {};
for (const [key, value] of urlParamss) {
    if (key === 'via' || key === 'cfclick' || key === 'pid' || key === 'fid' || key === 'freq' || key === 'state') {
        queryParams[key] = value;
        sessionStorage.setItem('queryParams', JSON.stringify(queryParams));
    }
}

// Sometime couple of query parameters are missing, we need to merge the old and the new
const updatedQueryParams = JSON.parse(sessionStorage.getItem('queryParams'));
if (savedQueryParams && updatedQueryParams) {
  $.extend(savedQueryParams, updatedQueryParams);
  sessionStorage.setItem('queryParams', JSON.stringify(savedQueryParams));
}

const referrer = document.referrer;
var url_string = window.location.href; 
var url = new URL(url_string);
var c = url.searchParams.get("param") || 'test' ;
if(c == 'orderfeedback'){
   document.getElementById("maincontain").style.display = "block";
        document.getElementById("load").style.display = "none";
}
if (referrer) {
    if (window.location.pathname == '/account' && referrer.includes("quiz.threadicated.com.au")) {
        document.getElementById("maincontain").style.display = "block";
        document.getElementById("load").style.display = "none";
    } else if (window.location.pathname == '/account' && c == 'test') {
        if (savedQueryParams && savedQueryParams.state && savedQueryParams.state === 'mp') {
          // flow for unauthenticated user when clicking menu Shop Personalized Link
          window.location.href = "https://store.xecurify.com/moas/broker/login/jwt/25489?client_id=jjFCgzWcuX2QF5K5&redirect_uri=https://www.threadicated.com.au/pages/mo-sso-marketplace";
        } else {
          window.location.href = "https://store.xecurify.com/moas/broker/login/jwt/25489?client_id=79i5iVUQS53PNMBL&redirect_uri=https://www.threadicated.com.au/pages/mo-sso";
        }      
    } else if (referrer.includes("/account/register")) {
        if (referrer.includes("state=buynow")) {
            // flow for regular registration, after succesfully sign in > redirect to buy now purchase
            window.location.href = "https://store.xecurify.com/moas/broker/login/jwt/25489?client_id=YHsvCk7tBxOW4kOx&redirect_uri=https://www.threadicated.com.au/pages/mo-sso-buy-now-purchase";
        } else {
            // flow for regular registration, after succesfully sign in > redirect to quiz section
            window.location.href = "https://store.xecurify.com/moas/broker/login/jwt/25489?client_id=84lqqhytGClWRxxt&redirect_uri=https://www.threadicated.com.au/pages/mo-sso-register";
        }
    }
}